export const saveActiveGiveawayTypeCreator = storePrefix => `${storePrefix}_SAVE_ACTIVE_GIVEAWAY`;
export const saveGiveawayModelActionFactory = storePrefix => model => ({
  type: saveActiveGiveawayTypeCreator(storePrefix),
  payload: model
});
export const updateActiveGiveawayTypeCreator = storePrefix => `${storePrefix}_UPDATE_ACTIVE_GIVEAWAY`;
export const updateActiveGiveawayModelActionFactory = storePrefix => model => ({
  type: updateActiveGiveawayTypeCreator(storePrefix),
  payload: model
});